import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder, matchHeights } from "../helpers"
import SubmitButton from "./elements/SubmitButton"
import { useEffect } from "preact/hooks"
import DropdownProduct from "./DropdownProduct"

export default function Autocomplete() {
    const { products, keywords } = useResponse();
    const { format } = useCurrencyFormatting();

    // useEffect(() => {
    //     const container = document.querySelector(".nosto-search-container")
    //     if (container) {
    //         if (!products?.hits?.length && !keywords?.hits?.length) {
    //             console.log("No results found")
    //             container.style.setProperty("height", "auto", "important")
    //         } else {
    //             console.log("Results found, removing height")
    //             container.style.removeProperty("height")
    //         }
    //     }
    // }, [products?.hits?.length, keywords?.hits?.length])

    useEffect(() => {
        const container = document.querySelector(".nosto-search-container");
        const input = document.querySelector("#nosto-search-input");
        
        const handleBlur = () => {
            if (container) {
                // console.log("Input lost focus, applying height auto")
                container.style.setProperty("height", "auto", "important")
            }
        }
        
        if (container) {
            if (!products?.hits?.length && !keywords?.hits?.length) {
                // console.log("No results found")
                container.style.setProperty("height", "auto", "important")
            } else {
                // console.log("Results found, removing height")
                container.style.removeProperty("height")
            }
        }
        
        if (input) {
            input.addEventListener("blur", handleBlur)
        }
        
        return () => {
            if (input) {
                input.removeEventListener("blur", handleBlur)
            }
        }
    }, [products?.hits?.length, keywords?.hits?.length])

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    useEffect(() => {
        if(!window.Nosto?.migrateToShopifyMarket) return;
        window.Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-autocomplete .ns-markets',
            productHandleAttribute: 'data-handle',
            productUrlElement: '.ns-autocomplete .ns-link',
            priceElement: '.ns-autocomplete .ns-price',
            listPriceElement: '.ns-autocomplete .ns-list-price',
        })
    }, [ products?.hits ])

    useEffect(()=>{
        setTimeout(() => {
            matchHeights(".ns-autocomplete .product-item__meta");
        }, 200);
    }, [products?.hits])

    return (
        <div
            class="ns-autocomplete ns-fixed ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
                    {/* {keywords?.hits?.length > 0 && ( */}
                        <div
                            class={`ns-autocomplete-keywords ${keywords?.hits?.length === 0 && "ns-empty-content"} ns-d-flex ns-flex-column ns-col-12 ${
                                products?.hits?.length > 0 ? "ns-col-sm-3" : "ns-col-sm-12"
                            }`}
                        >
                            <div class="ns-color-black ns-font-bold ns-autocomplete-heading ns-font-6">
                                Suggestions
                            </div>
                            <div class="ns-d-flex ns-flex-column ns-keywords-container">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                            {/* {!products?.hits?.length && <SubmitButton text="See all search results" />} */}
                        </div>
                    {/* )} */}
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1 ns-relative ns-col-12 ns-col-sm-9">
                            <div class="ns-d-flex ns-justify-content-between ns-align-items-center">
                                <div class="ns-color-black ns-autocomplete-heading ns-font-bold ns-font-6">
                                    Top Results
                                </div>
                                <SubmitButton text="View all results" />
                            </div>
                            <div class="ns-d-flex ns-autocomplete-products-container">
                                {products?.hits?.map(hit => {
                                    return (
                                        <DropdownProduct product={hit} key={hit?.productId} /> 
                                    )
                                })}
                            </div>
                            {/* <SubmitButton text="View All Results" /> */}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-font-5">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}

// <AutocompleteElement key={hit.productId} hit={hit}>
                                        //     <div
                                        //         data-url={hit.url}
                                        //         class="ns-d-flex flex-row ns-clickable ns-p-2"
                                        //         data-nosto-element="product"
                                        //     >
                                        //         <img
                                        //             class="ns-h-auto ns-object-contain"
                                        //             src={hit.imageUrl ?? productImagePlaceholder}
                                        //             alt={hit.name}
                                        //             width="60"
                                        //             height="40"
                                        //         />
                                        //         <div class="ns-pl-2">
                                        //             {hit.brand && (
                                        //                 <div class="ns-color-black ns-mb-1 ns-font-4">{hit.brand}</div>
                                        //             )}
                                        //             <div class="ns-mb-2 ns-font-4 ns-clipped ns-text-one-line">
                                        //                 {hit.name}
                                        //             </div>
                                        //             <div>
                                        //                 <span>{format(hit.price)}</span>
                                        //                 {hit.listPrice && hit.listPrice > hit.price && (
                                        //                     <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2">
                                        //                         {format(hit.listPrice)}
                                        //                     </span>
                                        //                 )}
                                        //             </div>
                                        //         </div>
                                        //     </div>
                                        // </AutocompleteElement>